import AccessApplication from "./AccessApplication"

export default AccessApplication